export default "__VITE_ASSET__BixN4lqT__"